<template>

  <el-dialog :title="title" :visible.sync="dialogFormVisible" custom-class="medium-dialog" center :append-to-body="true"
             :close-on-click-modal="false"
  >
    <el-row>
      <el-col :span="8">
        <div class="search-content">
          <div class="toobar">
            <h2>条形码扫码</h2>
          </div>
        </div>
        <div :style="'background-color: #F2F2F2;height:'+tableHeight(580)+'px;'">
          <el-form :model="form" ref="form1" style="padding-top: 60px;">
            <!--<el-row :gutter="20">-->
              <!--<el-col :span="20">-->
                <!--<el-form-item label="工牌" :label-width="formLabelWidth" prop="gh">-->
                  <!--<el-input v-model="form.gh" @change="dserialchange" ref="dserialinput"></el-input>-->
                <!--</el-form-item>-->
              <!--</el-col>-->
            <!--</el-row>-->
            <!--<el-row :gutter="20">-->
              <!--<el-col :span="20">-->
                <!--<el-form-item label="姓名" :label-width="formLabelWidth" prop="uname">-->
                  <!--<el-input v-model="form.uname" disabled></el-input>-->
                <!--</el-form-item>-->
              <!--</el-col>-->
            <!--</el-row>-->
            <el-row :gutter="20">
              <el-col :span="20">
                <el-form-item label="单号" :label-width="formLabelWidth" prop="jiagongcode">
                  <el-input v-model="form.jiagongcode" ref="jiagongcodeinput" @change="jiagongcodechange"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

          </el-form>

        </div>

      </el-col>
      <el-col :span="15" style="margin-left: 5px">
        <div class="grid-content bg-purple-light">
          <div class="search-content">
            <el-col class="toobar">
              <el-row>
                <h2 style="display: inline-block">订单详情
                </h2>
                <!--<el-button style="float: right" type="primary" @click="jiagong" size="mini" :loading="loading">-->
                  <!--{{title=='待加工'?'加工':title=='已加工'?'加工完成':'质检'}}-->
                <!--</el-button>-->
                <p></p>
              </el-row>
            </el-col>
          </div>
          <el-table :data="tableData" :height="tableHeight(170)" ref="table1"
                    size="mini" stripe border style="width: 100%;">
            <el-table-column
              width="50"
              label="序号"
              type="index"
              align="center">
            </el-table-column>
            <el-table-column
              prop="erpserial"
              label="订单号"
              align="left"
              header-align="center"
              width="300">
            </el-table-column>
            <!--<el-table-column-->
              <!--prop="seedname"-->
              <!--label="名称"-->
              <!--show-overflow-tooltip-->
              <!--align="left"-->
              <!--header-align="center">-->
              <!--<template slot-scope="scope">-->
                <!--<div style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width: 100%;height:24px;">-->
                  <!--{{scope.row.jxcformdetailDOList[0].seedname}}-->
                <!--</div>-->
              <!--</template>-->
            <!--</el-table-column>-->

            <!--<el-table-column-->
              <!--label="操作"-->
              <!--align="center"-->
              <!--width="80"-->
              <!--header-align="center">-->
              <!--<template slot-scope="scope">-->
                <!--<el-button size="mini" @click="datadelete(scope.$index,scope.row.erpserial)">删除</el-button>-->
              <!--</template>-->
            <!--</el-table-column>-->
          </el-table>
        </div>
      </el-col>

    </el-row>


  </el-dialog>
</template>

<script>
  import {saomasave} from '@/api/order/printlog';
  import {bathsaveData} from '@/api/set/handlelog';
  import {ghcode} from '@/api/set/employee';
  import {getCstagreementListDataNew, piliangfinishing,processorReceived} from '@/api/set/csagreement';

  export default {
    name: 'RapidMachining',
    data() {
      return {
        loading: false,
        dialogFormVisible: false,
        formLabelWidth:
          '90px',
        tableData:
          [],
        title:
          '',//标题
        form:
          {
            gh: '',//工牌
            jiagongcode:
              '',//加工单号
            uname:
              '',//姓名
            uguid:
              '',//员工唯一码
          }
        ,
      }
    },
    methods: {
      jiagong() {
        if (this.title == '开始加工') {
          this.startprint()
        } else if (this.title == '加工完成') {
          this.machiningOver()
        } else {
          this.zhijian()
        }
      },
      show(title) {
        this.init()
        this.dialogFormVisible = true
        this.title = title
        this.$nextTick(() => {
          this.$refs.jiagongcodeinput.focus();
        });
      },
      init() {
        this.title = ''
        this.form.gh = ''
        this.form.uname = ''
        this.form.jiagongcode = ''
        this.form.uguid = ''
        this.tableData = []
      },
      datadelete(index, erpserial) {
        this.tableData.splice(index, 1);
      },
      //工牌扫码
      dserialchange() {
        ghcode({gh: this.form.gh}).then(response => {
          if (response.data.obj.length == 0) {
            this.$message.error("无牌无效,请重新扫描！！");
            this.form.gh = ''
            this.form.uname = ''
            this.form.uguid = ''
            return
          }
          var ghdata = response.data.obj
          this.form.uname = ghdata[0].uname
          this.form.uguid = ghdata[0].uguid
        })
        this.$refs.jiagongcodeinput.focus();
      },
      jiagongcodechange() {
        var jgcode = this.form.jiagongcode.trim();
        if (!jgcode || jgcode.length != 14) return;
        processorReceived({erpserial: jgcode}).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '操作成功！',
              type: 'success'
            })
            this.tableData.push({erpserial:jgcode});
            this.$emit("bindGrid")
          } else {
            this.$message.error(response.data.msg);
          }
          this.form.jiagongcode = ''
        });
        // this.bindGrid();
      },
      //获取订单
      bindGrid() {
        var formData = {
          needtuihuoinfo: 0,
          offset: 0,
          limit: 20,
          search: this.form.jiagongcode.trim(),
          status: 300,
          statuses: '',
          formtype: this.formtype,
          needdetail: "1",
          isshowbuyinfo: 0,
          isshowstore: 0,
          isshowpayinfo: 1,
          isshowtuihuofrombuy: 0,
          neefahuoinfo: "0",
          isreturnorder: '-999',
          datetype: 10,
          invoicesource: this.title == '待加工' ? 2 : this.title == '已加工' ? 3 : '',
          needtotal: "-1",//不计算记录总数
        };
        getCstagreementListDataNew(formData, this.noloading).then(response => {
          if (response.data.obj.rows.length == 0) {
            this.$message.error("此订单不在这个状态");
            this.form.jiagongcode = ''
            return
          }
          if (this.tableData.length == 0) {
            this.tableData = response.data.obj.rows
          } else {
            for (let i in this.tableData) {
              if (this.tableData[i].erpserial == response.data.obj.rows[0].erpserial) {
                this.$message.error("订单已存在！！")
                this.form.jiagongcode = ''
                return
              }
            }
            this.tableData.push(response.data.obj.rows[0])
          }
          this.form.jiagongcode = ''
        }).catch((error) => {
        });
      },
      //待加工扫码后调用
      startprint() {
        var erpserials = ''
        if (this.tableData.length > 0) {
          for (let i in this.tableData) {
            if (i == 0) {
              erpserials = this.tableData[i].erpserial
            } else {
              erpserials = erpserials + "," + this.tableData[i].erpserial
            }
          }
        }
        if (!erpserials) {
          this.$message.error("无订单");
          this.loading = false
          return
        }
        this.loading = true
        saomasave({erpserials: erpserials, invoicesource: 5, jiagongshi: this.form.uname}).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '订单进入加工中',
              type: 'success'
            })
            this.dialogFormVisible = false
            this.$emit("bindGrid")
          } else {
            this.$message.error("操作失败！")
            this.loading = false
          }
        })
      },
      //已加工扫码调用
      machiningOver() {
        this.loading = true;
        var erpserials = ''
        if (this.tableData.length > 0) {
          for (let i in this.tableData) {
            if (i == 0) {
              erpserials = this.tableData[i].erpserial
            } else {
              erpserials = erpserials + "," + this.tableData[i].erpserial
            }
          }
        }
        if (!erpserials) {
          this.$message.error("无订单");
          this.loading = false
          return
        }
        piliangfinishing({erpserials: erpserials}).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '加工完成',
              type: 'success'
            })
            this.handlelog("加工完成");
          } else {
            this.loading = false
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        })
      },
      //处理日志
      handlelog(hn) {
        var handledata = []
        for (let i in this.tableData) {
          var handlelog = {}
          handlelog.erpserial = this.tableData[i].erpserial
          handlelog.isopen = 1
          handlelog.casestepname = hn
          handlelog.remark = hn
          handledata.push(handlelog)
        }
        bathsaveData({handledata: JSON.stringify(handledata)}).then(response => {
          if (response.data.code == 0) {
            this.dialogFormVisible = false
            this.$emit("bindGrid")
          } else {
            this.$message.error("日志生成失败");
          }
        })
      },
      zhijian() {
        if (this.tableData.length == 0) {
          this.$message.error("无订单");
          this.loading = false
          return
        }
        this.loading = true
        this.handlelog("质检")
      }
    },
    mounted() {

    },
    components: {}

  }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/RapidMachining.vue